// extracted by mini-css-extract-plugin
module.exports = {"notes":"ShippingAddressTab_notes__ckD3B"};